// components/BlogList.jsx
import React, { useState, useEffect } from 'react';
import BlogCard from './BlogCard.jsx';
import blogService from '../services/blogServices.js';

const BlogList = () => {
   const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load initial blogs
    loadBlogs();

    // Subscribe to real-time blog updates
    const unsubscribe = blogService.addListener(({ publishedBlogs }) => {
      setBlogs(publishedBlogs);
    });

    return () => unsubscribe();
  }, []);

  const loadBlogs = () => {
    setLoading(true);
    const publishedBlogs = blogService.getPublishedBlogs();
    setBlogs(publishedBlogs);
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
          <p className="mt-4 text-gray-600">Loading blogs...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* Blog Cards Grid */}
      <div className="flex flex-wrap items-start gap-6 p-10 justify-center">
        {blogs.length === 0 ? (
          <div className="text-center py-12 w-full">
            <svg className="mx-auto h-16 w-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
            </svg>
            <p className="my-2 md:text-md text-mm font-semibold text-secondary">No News Articles available.</p>
            <p className="my-2 text-sm font-medium text-gray-500">Check back later for new content!</p>
          </div>
        ) : (
          blogs.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))
        )}
      </div>
    </div>
  );
};

export default BlogList;